import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

const initialState = {
  isFetching: false,
  data: {},
  livePlayerData: {},
  isLoggedIn: false,
  IsFeedbackAvailable: false,
  feedbackURL: ''
};

export const digitalLiveClassReducer = createReducer(initialState, {
  [types.DIGITAL_LIVE_CLASS_RESPONSE](state, action) {
    return {
      ...state,
      timestamp: action.response.timestamp,
      data: action.response.data,
      IsFeedbackAvailable: action.response.IsFeedbackAvailable,
      feedbackURL: action.response.feedbackURL,
      errorMessage: action.response.message,
    };
  },
  [types.LIVE_CLASS_PLAYER_RESPONSE](state, action) {
    return {
      ...state,
      livePlayerData: action.response.data,
      errorMessage: action.response.message,
    };
  },
  [types.LOG_OUT]() {
    return {
      ...initialState,
    };
  },
});
